import React from "react";

const Hero = () => {
  const handleSmoothScroll = (e, href) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <>
      <section
        id="#"
        className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue to-dark-blue"
      >
              <div className="absolute bottom-0 z-10 rotate-180 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-full h-12"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className="fill-yellow"
          ></path>
        </svg>
      </div>
        {/* Content */}
        <div className="relative z-10 container mx-auto px-6 md:px-12 text-center md:text-right flex flex-row items-center justify-between">
          <div className="max-w-4xl mx-auto md:mr-0">
            {/* Main Title */}
            <h1 className="text-5xl md:text-7xl font-semibold text-white mb-2 leading-tight">
              هاكاثون قمة
            </h1>

            <h2 className="text-xl font-medium text-yellow my-4">
              ابنِ أداة تمكّن المبرمج العربي
            </h2>

            {/* Description */}
            <p className="text-lg md:text-xl text-gray-300/90 mb-4 leading-relaxed max-w-3xl mx-auto md:mr-0">
              هاكاثون مخصص للمطورين العرب لصناعة أدوات مفتوحة المصدر تسهم في
              تطوير بيئة البرمجة بالعربية، وتخدم المجتمع التقني العربي.
            </p>
            <p className="text-lg md:text-xl text-gray-300/90 mb-8 leading-relaxed max-w-3xl mx-auto md:mr-0">
              هدفنا بناء أدوات تعليمية، تطويرية، أو توثيقية تسهّل حياة المبرمج
              العربي وتثري المحتوى البرمجي بلغتنا.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 items-center">
              <button
                disabled
                className="px-8 py-3 opacity-50 bg-yellow text-dark-blue font-semibold text-lg rounded-xl cursor-not-allowed w-full sm:w-auto"
              >
                <span className="relative z-10">سجّل الآن</span>
              </button>

              <a
                href="#about"
                onClick={(e) => handleSmoothScroll(e, '#about')}
                className="px-8 py-3 bg-transparent text-white font-semibold text-lg rounded-xl border-2 border-white/30 hover:border-yellow hover:bg-white/5 transition-all  w-full sm:w-auto"
              >
                اعرف أكثر
              </a>
            </div>
          </div>
          <div>
            <img
              src={`${process.env.PUBLIC_URL}/logo.svg`}
              alt="logo"
              className="w-[20vw] max-w-lg logo-animation hidden lg:block"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
